import { trackWebVital } from './utils/analytics';

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS((metric) => {
        onPerfEntry(metric);
        trackWebVital(metric);
      });
      getFID((metric) => {
        onPerfEntry(metric);
        trackWebVital(metric);
      });
      getFCP((metric) => {
        onPerfEntry(metric);
        trackWebVital(metric);
      });
      getLCP((metric) => {
        onPerfEntry(metric);
        trackWebVital(metric);
      });
      getTTFB((metric) => {
        onPerfEntry(metric);
        trackWebVital(metric);
      });
    });
  }
};

export default reportWebVitals;
